<template>
  <div class="grid-container">
    <form :class="{'opacity-50': isWorking}" @submit.prevent="submit">
      <section-header class="mt-3" variants="dividing" size="xl">
        <heading level="1" size="xl" v-html="bp('text.editProfile')"></heading>
      </section-header>
      <callout v-if="message" :icon="messageIcon" :type="messageType">{{ message }}</callout>
      <div class="max-w-sm mb-6">
        <form-group
          v-model="firstNameValue"
          v-validate="'required'"
          type="text"
          name="firstName"
          :label="bp('profile.firstName')"
          :data-vv-as="bp('profile.firstName')"
          :error="errors.first('firstName')"
          :show-error-messages="true"
          :maxlength="19"
          required
        />
        <form-group
          v-model="lastNameValue"
          v-validate="'required'"
          type="text"
          name="lastName"
          :label="bp('profile.lastName')"
          :data-vv-as="bp('profile.lastName')"
          :error="errors.first('lastName')"
          :show-error-messages="true"
          :maxlength="19"
          required
        />

        <div class="buttons">
          <trek-button primary type="submit" :disabled="isWorking" @click="submit">
            <span v-html="bp('text.account.profile.saveUpdates')"></span>
          </trek-button>
          <trek-button secondary @click="cancel"><span v-html="bp('text.account.profile.cancel')"></span></trek-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import get from 'lodash/get';
import Heading from '@/components/Heading';
import Callout from '@/components/Callout';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton';
import SectionHeader from '@/components/SectionHeader';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base';

export default {
  name: 'EditProfileContainer',
  components: {Heading, Callout, FormGroup, TrekButton, SectionHeader},
  extends: UserAccountBase,
  props: {
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      firstNameValue: '',
      lastNameValue: '',
    };
  },
  mounted() {
    this.firstNameValue = this.firstName;
    this.lastNameValue = this.lastName;
  },
  methods: {
    /**
     * Handle email update.
     * @return {Promise<void>}
     */
    async processUpdate() {
      this.isWorking = true;
      try {
        const response = await this.api.updateProfile({
          firstName: this.firstNameValue,
          lastName: this.lastNameValue,
          CSRFToken: this.options.CSRFToken,
        });

        const isError = get(response.data.meta, 'feedback.type') !== 'success';
        const message = get(response.data.meta, 'feedback.message.basePropertyValue');
        this[isError ? 'displayError' : 'displaySuccess'](message);
      } catch (e) {
        this.displayError(e.message);
      } finally {
        this.isWorking = false;
      }
    },
  },
};
</script>
